import {Component, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {Modulo, modulosActivos} from "./Modulo";
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {MsalService} from "@azure/msal-angular";
import { environment } from '../../environments/environment';
import {GroupsMSGraph, ResponseMSGraph} from "../graphInterface/GraphInterfaces";
import { AccountInfo, AuthenticationResult, SilentRequest } from '@azure/msal-browser';

@Component({
  selector: 'ral-hub',
  templateUrl: './hub.component.html',
  styleUrls: ['./hub.component.scss']
})

export class HubComponent implements OnInit, OnDestroy {
  modulos: Modulo[] = [];

  constructor(private router: Router, private http: HttpClient, private msalService: MsalService){

  }

  ngOnInit() {
    this.getAccessTokenAndCallGraphAPI();
    document.body.style.background = "#e2ede7";

  }

  getAccessTokenAndCallGraphAPI(){

    if (!this.msalService.instance.getActiveAccount()){
      this.msalService.instance.handleRedirectPromise().then((result) => {
        if (result !== null && result.account !== null) {
          this.msalService.instance.setActiveAccount(result.account);
        } else {
          this.checkAccount();
        }
      });
    }

    this.msalService.acquireTokenSilent({
      scopes: ['GroupMember.Read.All']
    }).subscribe(resultado=>{

      const httpOptions = {
        headers: new HttpHeaders().set('Authorization', 'Bearer ' + resultado.accessToken)}
      //https://graph.microsoft.com/v1.0/groups?$filter=startswith(displayName,'RalarsaWeb-')
      this.http.get("https://graph.microsoft.com/v1.0/me/memberOf?$select=id,mail", httpOptions).subscribe(result=> {
        var gruposUsuario: ResponseMSGraph = JSON.parse(JSON.stringify(result));
        this.getGroupsHubPermissions(gruposUsuario, resultado.accessToken)
      });
    })
  }

  checkAccount() {
    const currentAccounts = this.msalService.instance.getAllAccounts();

    if (currentAccounts === null || currentAccounts.length === 0) {
      this.attemptSSOSilent();
    } else {
      this.msalService.instance.setActiveAccount(currentAccounts[0]);
    }
  }

  attemptSSOSilent() {
    const silentRequest: SilentRequest = {
      scopes: ['User.Read']
    };

    this.msalService.instance
      .ssoSilent(silentRequest)
      .then((result: AuthenticationResult) => {
        this.msalService.instance.setActiveAccount(result.account);
      })
      .catch((error) => {
        console.error('Silent SSO failed, prompting for login:', error);
        this.msalService.loginRedirect(); // Redirect to Microsoft login page
      });
  }


  getGroupsHubPermissions(userGroups: ResponseMSGraph, token:string){
    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);
    options = options.set('Access-Control-Allow-Credentials', 'true');

    if (!environment.production){
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }
    let gruposUsuarioArray = "[";
    for (let i = 0; i < userGroups.value.length; i++) {
      let grupo: GroupsMSGraph = userGroups.value[i];
      gruposUsuarioArray += "\"" + grupo.id.toString() + "\",";
    }
     gruposUsuarioArray = gruposUsuarioArray.substring(0, gruposUsuarioArray.length-1) + "]";

    let postData = "{\"userId\":\"" + this.msalService.instance.getActiveAccount()?.localAccountId + "\",\"grupoIds\":" + gruposUsuarioArray + "}";

    this.http.post(environment.azureWSBase + "/Groups/hubGroups", postData, httpOptions).subscribe(result=> {
      let jsonRespuesta = JSON.parse(result.toString());
      for (let i = 0; i < jsonRespuesta["response"].length; i++) {
        let modulName = jsonRespuesta["response"][i];
        let nuevoModulo: Modulo = modulosActivos[modulName];
        this.modulos.push(nuevoModulo);
      }
      document.getElementById("contenedor-carga")!.className = "ocultar";
    });

  }

  logout() {
    this.msalService.logout();
  }

  ngOnDestroy(){
    document.body.style.background = "";
  }

}
